(ns common.app
  (:require ["@launchdarkly/observability$default" :as Observability]
            ["@launchdarkly/session-replay$default" :as SessionReplay]
            ["@launchdarkly/toolbar" :refer [FlagOverridePlugin useLaunchDarklyToolbar]]
            ["@tanstack/react-query-devtools" :refer [ReactQueryDevtools]]
            ["launchdarkly-react-client-sdk" :refer [asyncWithLDProvider]]
            [common.announcement.view :as announcement]
            [common.db.config :as config]
            [common.flags :as flags]
            [common.google-analytics :as ga]
            [common.loader.view :as loader]
            [common.locale :as locale]
            [common.modal.view :as modal]
            [common.mui :as mui]
            [common.ocp.view :as ocp]
            [common.os :as os]
            [common.queries :as queries]
            [common.queries.http :as qhttp]
            [common.router :as router]
            [common.toaster-bus.view :as toaster]
            [common.util :refer [spread-props]]
            [reagent.core :as r]
            [reagent.dom.client :as rdomc]
            [uix.core :as uix :refer [$ defui defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(def LD-client-side-id (:launchDarklyClientSideId (config/get-config)))

(defonce flagOverridePlugin (FlagOverridePlugin.))

(defn running-in-playwright? []
  js/navigator.webdriver)

(defui launch-darkly-runtime []
  (flags/use-identify-context)
  (useLaunchDarklyToolbar
   #js {:flagOverridePlugin flagOverridePlugin
        :position "bottom-right"
        :enabled (and (not (config/production-env?))
                      (not (running-in-playwright?)))}))

(defhook use-init-ga4
  []
  (let [os-environment? (os/os-environment?)
        os-context (use-subscribe [::os/context])
        initialized (uix/use-ref false)]
    (uix/use-effect
     (fn []
       (when-not @initialized
         (cond
           (not os-environment?)
           (do
             (ga/web-init-ga4!)
             (reset! initialized true))

           (and os-environment? os-context)
           (do
             (ga/native-init-ga4! {:osContext os-context})
             (reset! initialized true)))))
     [os-context os-environment?])))

(defui app-wrapper [{:keys [children]}]
  ($ locale/locale-provider
     ($ os/os-provider
        (use-init-ga4)
        ($ mui/theme-provider
           ($ queries/query-provider {}
              (when-not (running-in-playwright?)
                ($ ReactQueryDevtools {:initialIsOpen false
                                       :buttonPosition "bottom-left"}))
              ($ launch-darkly-runtime)
              (when-not (running-in-playwright?)
                ($ announcement/announcement-runtime))
              children)))))

(defui app-root-component []
  ($ :<>
     ($ ocp/ocp-root)
     (r/as-element [modal/modal-root])
     (r/as-element [loader/loader-root])
     ($ toaster/toaster-root)
     ($ router/router-component)))

(defonce app-node (rdomc/create-root (.getElementById js/document "app")))

(defn start-app! []
  (-> (asyncWithLDProvider
       #js {:clientSideID LD-client-side-id
            :options (spread-props #js {:plugins (if (config/production-env?)
                                                   #js [(Observability.)
                                                        (SessionReplay.)]
                                                   #js [flagOverridePlugin])}
                                   (when (.-launchDarklyProxied js/window.__LEMONPI_CONFIG__)
                                     (let [url (qhttp/render :api/feature-flags-proxy {})]
                                       #js {:streamUrl url
                                            :baseUrl url
                                            :eventsUrl url})))})
      (.then (fn [LDProvider]
               (rdomc/render app-node ($ uix/strict-mode
                                         ($ LDProvider
                                            ($ app-wrapper
                                               ($ app-root-component)))))))))

(defn stop-app! []
  (rdomc/unmount app-node))
